import Reveal from "./Reveal";
import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1521737711867-e3b97375f902?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5JTIwdGVhbXxlbnwwfHx8fDE3ODM2MDYyMDN8MA&ixlib=rb-4.1.0&q=85";

const points = [
  "PR & strategic communications at the core",
  "Conferences, summits, awards & exhibitions",
  "Trusted by governments, institutions & industry",
];

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-28 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="relative">
            <div className="absolute -top-5 -left-5 w-28 h-28 border-t-4 border-l-4 border-[#D91C29] rounded-tl-2xl" />
            <img
              src={ABOUT_IMG}
              alt="The Urzu Media team collaborating"
              className="relative rounded-2xl shadow-xl w-full object-cover aspect-[4/3]"
            />
            <div className="absolute -bottom-6 -right-4 sm:right-6 bg-[#0B1B3D] text-white rounded-xl px-6 py-5 shadow-2xl">
              <p className="font-serif-display text-4xl font-bold leading-none">10<span className="text-[#D91C29]">+</span></p>
              <p className="text-xs uppercase tracking-widest text-slate-300 mt-1">Years of expertise</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div>
            <p className="text-xs uppercase tracking-widest text-[#D91C29] font-semibold">Who we are</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl font-bold text-[#0B1B3D] tracking-tight mt-3 leading-tight">
              An integrated media & communications partner built on trust
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              For nearly a decade, Urzu Media has conceptualised and delivered conferences,
              summits, public dialogues, awards, exhibitions and knowledge initiatives across
              travel, tourism, technology, IT, startups, business, public policy and governance.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              As service providers and communications consultants, we work at the intersection
              of industry, government, academia and civil society — designing initiatives that
              foster meaningful dialogue, knowledge exchange and lasting stakeholder engagement.
            </p>

            <ul className="mt-7 space-y-3">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-slate-700">
                  <CheckCircle2 size={20} className="text-[#D91C29] mt-0.5 shrink-0" />
                  <span className="font-medium">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
